import React from 'react';

import classNames from './EABD2ScreenContainer.module.scss';

export interface ScreenContainerProps
  extends Readonly<{
    children?: React.ReactNode;
  }> {}

export const ScreenContainer = React.memo<ScreenContainerProps>((props) => {
  const { children } = props;

  return <div className={classNames.root}>{children}</div>;
});
